import {defineMessages} from 'react-intl'

export const monthlyPriceTrendMessages = defineMessages({
  title: {
    id: 'monthlyAveragePrices',
    defaultMessage: 'Monthly average prices'
  },
  tableCaption: {
    id: 'averageNightlyPriceByMonthAtHotel',
    defaultMessage:
      'Average nightly price at {hotelName} by month, last 12 months ({currency})'
  },
  summary: {
    id: 'monthlyPriceTrendSummary',
    defaultMessage:
      'Nightly prices at {hotelName} average {cheapestPrice} in {cheapestMonth}, the cheapest month, and {mostExpensivePrice} in {mostExpensiveMonth}, the most expensive, based on the last 12 months.'
  },
  monthColumnHeader: {
    id: 'month',
    defaultMessage: 'Month'
  },
  averagePriceColumnHeader: {
    id: 'averagePrice',
    defaultMessage: 'Average price'
  },
  pin: {
    id: 'monthAndAveragePrice',
    defaultMessage: '{month} · {price}'
  },
  mostExpensive: {
    id: 'mostExpensiveMonthAveragePrice',
    defaultMessage: 'Most expensive: {month} (~{price})'
  },
  cheapest: {
    id: 'cheapestMonthAveragePrice',
    defaultMessage: 'Cheapest: {month} (~{price})'
  }
})
